// extracted by mini-css-extract-plugin
export default {"DataTable":"DeleteUser_DataTable__psFQ3","ButtonSearch":"DeleteUser_ButtonSearch__IVzD7","ButtonSeeMore":"DeleteUser_ButtonSeeMore__wsO5s"};